var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminConsole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 451,
    viewBox: "0 0 802 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16864_457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 802,
    height: 451
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M801.717 0L1 0.5L0.833252 450.899H801.717V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16864_457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 451H802V0.54248H1V451Z",
    fill: "#46B4DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.026 342.6L455.286 375.349L446.274 341.97L347.026 342.6Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.328 128.382H522.333C533.738 128.382 543 137.531 543 148.637V305.814H248.659V148.637C248.659 137.532 257.922 128.382 269.328 128.382Z",
    fill: "#3A4553"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.328 128.382H522.333C533.738 128.382 543 137.531 543 148.637V305.814L248.659 148.637C248.659 137.532 257.922 128.382 269.328 128.382Z",
    fill: "#9DA5AC",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.393 75.042H490.643C495.442 75.0429 499.338 78.3315 499.338 82.3871V217.437C499.338 221.49 495.442 224.779 490.64 224.779L345.393 224.781C340.594 224.779 336.699 221.49 336.699 217.435V82.3862C336.699 78.3315 340.591 75.042 345.393 75.042Z",
    fill: "#FFFDFF",
    stroke: "#006291",
    strokeWidth: 1.1339,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.393 72.708H490.705C495.43 72.708 499.338 76.6191 499.338 81.4152V96.5592H336.699V81.4152C336.699 76.6191 340.604 72.708 345.393 72.708Z",
    fill: "#005F87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.103 84.4438C371.103 81.8654 369.015 79.7744 366.441 79.7744C363.864 79.7744 361.776 81.8654 361.776 84.4438C361.776 87.0222 363.864 89.1132 366.441 89.1132C369.015 89.1132 371.103 87.0222 371.103 84.4438Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.861 84.4438C356.861 81.8654 354.773 79.7744 352.196 79.7744C349.622 79.7744 347.534 81.8654 347.534 84.4438C347.534 87.0222 349.622 89.1132 352.196 89.1132C354.773 89.1132 356.861 87.0222 356.861 84.4438Z",
    fill: "#EBF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.036 84.4438C386.036 81.8654 383.948 79.7744 381.374 79.7744C378.797 79.7744 376.709 81.8654 376.709 84.4438C376.709 87.0222 378.797 89.1132 381.374 89.1132C383.948 89.1132 386.036 87.0222 386.036 84.4438Z",
    fill: "#C4337C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.692 121.95H477.62V117.915H354.692V121.95Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.692 140.981H477.62V136.946H354.692V140.981Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.692 159.997H477.62V155.961H354.692V159.997Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.692 179.026H417.669V174.991H354.692V179.026Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.692 198.058H417.669V194.023H354.692V198.058Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.292 186.08L449.178 198.592L473.042 177.852",
    stroke: "#3AA9AE",
    strokeWidth: 2.2677,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.395 106.231H590.645C595.444 106.232 599.339 109.52 599.339 113.576V248.625C599.339 252.679 595.444 255.968 590.641 255.968L445.395 255.969C440.593 255.968 436.7 252.679 436.7 248.624L436.697 113.575C436.7 109.52 440.593 106.231 445.395 106.231Z",
    fill: "#FFFDFF",
    stroke: "#006291",
    strokeWidth: 1.1339,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.395 103.897H590.707C595.431 103.897 599.339 107.808 599.339 112.604V127.748H436.697V112.604C436.697 107.808 440.605 103.897 445.395 103.897Z",
    fill: "#005F87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.003 305.815V330.93C543.003 338.375 537.334 344.494 530.338 344.494H261.329C254.334 344.494 248.663 338.375 248.663 330.93V305.815H543.003Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.421 325.881C525.421 322.676 522.825 320.077 519.621 320.077C516.421 320.077 513.825 322.676 513.825 325.881C513.825 329.086 516.421 331.685 519.621 331.685C522.825 331.685 525.421 329.086 525.421 325.881Z",
    fill: "#3AA9AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.708 325.881C506.708 322.676 504.112 320.077 500.911 320.077C497.708 320.077 495.112 322.676 495.112 325.881C495.112 329.086 497.708 331.685 500.911 331.685C504.112 331.685 506.708 329.086 506.708 325.881Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.939 325.881C488.939 322.676 486.343 320.077 483.139 320.077C479.939 320.077 477.343 322.676 477.343 325.881C477.343 329.086 479.939 331.685 483.139 331.685C486.343 331.685 488.939 329.086 488.939 325.881Z",
    fill: "#424C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.104 115.633C471.104 113.054 469.016 110.963 466.442 110.963C463.865 110.963 461.777 113.054 461.777 115.633C461.777 118.211 463.865 120.302 466.442 120.302C469.016 120.302 471.104 118.211 471.104 115.633Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.863 115.633C456.863 113.054 454.778 110.963 452.201 110.963C449.627 110.963 447.539 113.054 447.539 115.633C447.539 118.211 449.627 120.302 452.201 120.302C454.778 120.302 456.863 118.211 456.863 115.633Z",
    fill: "#EBF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.151 375.539L347.026 342.6L455.286 375.349L339.151 375.539Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.04 115.633C486.04 113.054 483.953 110.963 481.378 110.963C478.801 110.963 476.713 113.054 476.713 115.633C476.713 118.211 478.801 120.302 481.378 120.302C483.953 120.302 486.04 118.211 486.04 115.633Z",
    fill: "#C4337C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.255 373.015H473.878C478.885 373.012 482.949 377.365 482.949 382.732C482.949 388.093 478.885 392.449 473.874 392.449H321.255C316.247 392.449 312.183 388.096 312.183 382.732C312.183 377.362 316.247 373.012 321.258 373.012",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.802 168.58C275.059 168.58 300.398 193.952 300.398 225.25C300.398 256.548 275.059 281.921 243.802 281.921C212.546 281.921 187.207 256.548 187.207 225.25C187.207 193.952 212.546 168.58 243.802 168.58Z",
    fill: "#C4337C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.005 308.435C225.879 308.435 235.503 318.071 235.503 329.959C235.503 341.851 225.879 351.487 214.005 351.487C202.132 351.487 192.509 341.851 192.509 329.959C192.509 318.071 202.132 308.435 214.005 308.435Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.37 389.603H254.895C254.112 354.364 172.279 351.159 171.37 389.603Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.694 153.139H577.622V149.104H454.694V153.139Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.694 172.17H577.622V168.135H454.694V172.17Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.694 191.186H577.622V187.15H454.694V191.186Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.694 210.216H517.671V206.181H454.694V210.216Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.694 229.247H517.671V225.212H454.694V229.247Z",
    fill: "#354453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.477 321.566C590.775 321.631 586.151 323.232 588.806 318.349C583.543 316.782 584.571 315.587 583.477 321.566Z",
    fill: "#FBE594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.201 296.51L578.482 304.256C578.482 304.256 568.915 297.387 568.949 295.921C568.983 294.439 575.926 286.913 577.877 286.963C579.812 287.031 586.201 296.51 586.201 296.51Z",
    fill: "#005F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.445 296.51L625.179 304.256C625.179 304.256 634.749 297.387 634.696 295.921C634.665 294.439 627.719 286.913 625.787 286.963C623.836 287.031 617.445 296.51 617.445 296.51Z",
    fill: "#005F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.693 288.614H597.955V282.047H605.693V288.614Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.27 322.102C637.27 341.701 621.399 357.581 601.826 357.581C582.252 357.581 566.397 341.701 566.397 322.102C566.397 302.503 582.252 286.609 601.826 286.609C621.399 286.609 637.27 302.503 637.27 322.102Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.277 322.102C628.277 336.737 616.438 348.588 601.826 348.588C587.214 348.588 575.375 336.734 575.375 322.102C575.375 307.472 587.214 295.618 601.826 295.618C616.438 295.618 628.277 307.473 628.277 322.102Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.07 322.106C626.07 335.508 615.226 346.385 601.823 346.385C588.438 346.385 577.575 335.508 577.575 322.106C577.575 308.685 588.438 297.825 601.823 297.825C615.226 297.825 626.07 308.685 626.07 322.106Z",
    fill: "#FFFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.239 284.069H596.31C596.31 284.069 594.393 279.388 595.469 278.984C596.528 278.58 606.753 278.412 608.08 278.984C609.426 279.557 607.239 284.069 607.239 284.069Z",
    fill: "#005F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.673 323.719L601.187 323.519C600.614 323.266 600.361 322.608 600.598 322.052L607.594 305.502C607.828 304.93 608.485 304.677 609.056 304.913L609.542 305.114C610.096 305.351 610.368 306.007 610.134 306.579L603.138 323.132C602.885 323.687 602.228 323.956 601.673 323.719Z",
    fill: "#C4337C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.693 322.102C605.693 324.243 603.96 325.959 601.826 325.959C599.691 325.959 597.974 324.243 597.974 322.102C597.974 319.964 599.691 318.229 601.826 318.229C603.96 318.229 605.693 319.964 605.693 322.102Z",
    fill: "#C4337C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.294 217.268L549.176 229.78L573.044 209.041",
    stroke: "#3AA9AE",
    strokeWidth: 6,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.105 196.802L249.189 203.508C248.529 203.296 247.867 203.147 247.203 203.06C246.539 202.973 245.869 202.912 245.194 202.88L240.61 194.397L225.327 200.314L227.671 209.678C227.414 209.919 227.185 210.164 226.982 210.417L225.72 211.99C225.517 212.243 225.327 212.52 225.147 212.823L215.509 212.544L213.023 228.76L222.283 231.419C222.46 232.074 222.673 232.723 222.92 233.37C223.167 234.017 223.445 234.623 223.755 235.193L218.701 243.397L231.498 253.695L238.413 246.989C239.073 247.201 239.735 247.351 240.399 247.438C241.063 247.525 241.732 247.585 242.409 247.618L246.993 256.101L262.274 250.184L259.929 240.819C260.187 240.578 260.417 240.333 260.619 240.08L261.883 238.507C262.085 238.255 262.256 237.962 262.397 237.627L272.034 237.907L274.519 221.691L265.319 219.078C265.141 218.424 264.929 217.775 264.682 217.128C264.436 216.482 264.156 215.875 263.847 215.305L268.901 207.101L256.105 196.802ZM256.436 204.738L261.031 208.437L256.89 215.265C257.842 216.543 258.59 217.899 259.135 219.326C259.68 220.756 260.035 222.241 260.202 223.782L267.877 226.028L266.967 231.815L258.925 231.574C258.684 232.273 258.36 232.956 257.954 233.62C257.548 234.285 257.096 234.927 256.598 235.549C256.098 236.17 255.569 236.75 255.008 237.29C254.448 237.829 253.852 238.292 253.222 238.68L255.186 246.492L249.738 248.626L245.943 241.546C244.373 241.752 242.833 241.743 241.322 241.517C239.812 241.292 238.331 240.85 236.879 240.194L231.167 245.759L226.571 242.06L230.712 235.232C229.76 233.954 229.011 232.6 228.467 231.171C227.923 229.742 227.567 228.257 227.4 226.717L219.724 224.47L220.635 218.683L228.63 218.982C228.903 218.244 229.235 217.551 229.624 216.907C230.015 216.261 230.474 215.61 231.005 214.95C231.504 214.328 232.025 213.757 232.57 213.237C233.115 212.717 233.719 212.245 234.38 211.818L232.416 204.005L237.864 201.871L241.658 208.952C243.229 208.747 244.769 208.755 246.281 208.98C247.79 209.205 249.272 209.647 250.723 210.303L256.436 204.738ZM250.463 217.188C252.712 218.999 253.992 221.34 254.304 224.212C254.616 227.084 253.869 229.644 252.061 231.897C250.253 234.149 247.916 235.431 245.048 235.743C242.18 236.055 239.621 235.306 237.372 233.495C235.083 231.654 233.794 229.307 233.501 226.45C233.209 223.594 233.966 221.041 235.774 218.789C237.582 216.536 239.91 215.247 242.758 214.919C245.607 214.591 248.176 215.348 250.463 217.188Z",
    fill: "#FFFDFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminConsole);
export default __webpack_public_path__ + "static/media/admin-console.2dcff5d5efe06016a0ea8464e3d2b0d3.svg";
export { ForwardRef as ReactComponent };